import * as React from "react"
const BellIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#ACACAC"
      d="m15.506 11.3-1.733-6.247a6.214 6.214 0 0 0-12.056.314L.377 11.4a2 2 0 0 0 1.952 2.433h2.404a3.333 3.333 0 0 0 6.534 0h2.313a2.001 2.001 0 0 0 1.926-2.533ZM8 15.167a2 2 0 0 1-1.877-1.334h3.754A2 2 0 0 1 8 15.167Zm6.11-2.93a.66.66 0 0 1-.533.263H2.329a.666.666 0 0 1-.651-.811l1.34-6.034a4.88 4.88 0 0 1 9.467-.248l1.734 6.248a.663.663 0 0 1-.11.582Z"
    />
  </svg>
)
export default BellIcon
